import React from "react";
import { Link } from "react-router-dom";
import { SERIAL_METRIC_FIELDS } from "../../../utils/serialisationReportUtils";
import {
  findCompanyByInn,
  resolveManagersForCompany,
} from "../../../utils/reportManagerFilterUtils";

const GRID_CLASS = "cc-v4-soft-grid reports-serialisation-grid";

export const ItemSerialisationReport = ({
  s,
  columnVisibility,
  gridStyle,
  companys,
}) => {
  const { responsible, support } = resolveManagersForCompany(
    findCompanyByInn(companys, s.inn),
  );

  return (
    <Link
      className={`cc-v4-soft-row ${GRID_CLASS} reports-soft-row reports-serial-row`}
      style={gridStyle}
      to={`/company/${s.inn}`}
    >
      <span className="reports-cell">{s.name_company}</span>
      <span className="reports-cell company-card-v4-mono">{s.inn}</span>
      <span
        className={`reports-cell${
          responsible.muted ? " reports-cell-muted" : ""
        }`}
      >
        {responsible.text}
      </span>
      <span
        className={`reports-cell${support.muted ? " reports-cell-muted" : ""}`}
      >
        {support.text}
      </span>
      {SERIAL_METRIC_FIELDS.map((field) =>
        columnVisibility[field] ? (
          <span
            key={field}
            className="reports-cell reports-cell-numeric"
          >
            {s[field]}
          </span>
        ) : null,
      )}
    </Link>
  );
};

export { GRID_CLASS as SERIAL_REPORT_GRID_CLASS };
